module.exports = __webpack_public_path__ + "static/Step 3.5v2-5c1a587863895dd8256a5795e48c777e.png";